export default class AppInit {
    static loaded: boolean = false;

    static WAIT_ONLOAD_SELECTOR = "link[rel='stylesheet'].js-waitOnLoad";
    static LOAD_ERROR_CLASS = "js-loadError";

    static ON_INIT_FNS: Function[] = [];
    static ON_LOADED_FNS: Function[] = [];

    private static stylesLoaded(): Promise<void[]> {
        return Promise.all(
            Array.from(document.querySelectorAll<HTMLLinkElement>(AppInit.WAIT_ONLOAD_SELECTOR))
                .map(linkEl => new Promise<void>(resolve => {
                    if (linkEl.sheet) { return resolve(); }
                    if (linkEl.classList.contains(AppInit.LOAD_ERROR_CLASS)) { return resolve(); }
                    linkEl.addEventListener("load", () => resolve());
                    linkEl.addEventListener("error", () => resolve());
                }))
        );
    }

    /** Spustit před inicializaci modulů. */
    static onInit(fn: Function): void {
        AppInit.ON_INIT_FNS.push(fn);
    }
    
    /** Spustit po inicializaci modulů. */
    static onLoaded(fn: Function): void {
        AppInit.ON_LOADED_FNS.push(fn);
    }

    static init(): void {
        window.addEventListener('DOMContentLoaded', async () => {
            await AppInit.stylesLoaded();

            AppInit.ON_INIT_FNS.forEach(fn => fn());
            AppInit.loaded = true;
            AppInit.ON_LOADED_FNS.forEach(fn => fn());
        });
    }
}
